<template>
    <div style="min-height: 400px;">
        <gcmcn-filters
            ref="gcmcn-filters"
            style="margin-top: 18px;"
            :filter-values="[selectedSortType, searchFilter, selectedRegionsForFilter, selectedEntitiesForFilter, selectedTakersForFilter]"
            @reset-filters="resetFilters"
        >
            <dropdown
                name="Sort"
                :multiple="false"
                :list="$store.getters.sortTypeList"
                itemName="name"
                itemValue="value"
                :itemsSelected="selectedSortType.length > 0 ? [selectedSortType] : []"
                @on-select-item="selectedSortType = $event"
            ></dropdown>
            <dropdown
                name="AWS Regions"
                :multiple="true"
                :list="$store.getters.awsregionsSortedByName"
                itemName="display_name"
                itemValue="uid"
                :itemsSelected="selectedRegionsForFilter"
                @on-select-item="onSelectRegions"
            ></dropdown>
            <dropdown
                name="Takers"
                :multiple="true"
                :list="availableTakers"
                itemName="name"
                itemValue="uid"
                :itemsSelected="selectedTakersForFilter"
                @on-select-item="onSelectTakers"
            ></dropdown>
            <dropdown
                name="Entities"
                :multiple="true"
                :list="availableEntities"
                itemName="display_name"
                itemValue="uid"
                :itemsSelected="selectedEntitiesForFilter"
                @on-select-item="onSelectEntity"
            ></dropdown>
            <search-filter ref="search" @new-value="searchFilter = $event"></search-filter>
        </gcmcn-filters>
        <div v-if="filteredIrds.length > 0" style="overflow-y: scroll;" :style="{height: `calc(100vh - ${usedHeight}px)`}">
            <ird-card
                v-for="ird in filteredIrds"
                :key="ird.uid"
                :ird="ird"
                :selected-ird-uid="selectedIrdUid"
                @change-selected-ird="changeSelectedIrd"
            >
            </ird-card>
        </div>
        <div v-else-if="$store.getters.irds.length > 0" class="list-empty">
            No receiver(s) match this filters.
        </div>
        <div v-else class="list-empty">
            No receiver(s).
        </div>
    </div>
</template>

<script>
import IrdCard from './irdCard.vue';
import { mapGetters } from 'vuex';
import {
    GcmcnFilters,
    Dropdown,
    SearchFilter
} from 'gcmcn-common';
export default {

    components: {
        IrdCard,
        GcmcnFilters,
        Dropdown,
        SearchFilter,
    },

    props: {
        selectedIrdUid: {
            type: String,
            required: true,
        },
    },

    data (){
        return {
            selectedRegionsForFilter: [],
            searchFilter: '',
            selectedSortType: 'asc',
            usedHeight: 0
        };
    },

    computed: {
        ...mapGetters([
            'windowWidth',
            'userIsEntityAdmin',
            'administrableEntitiesUids',
            'takers',
            'entities',
            'selectedEntitiesForFilter',
            'selectedTakersForFilter',
        ]),
        availableTakers(){
            if(this.userIsEntityAdmin()){
                return this.takers.filter(
                    taker => this.administrableEntitiesUids.includes(taker.scopes.entity_uid)
                );
            }
            return this.takers;
        },
        availableEntities(){
            if(this.userIsEntityAdmin()){
                return this.entities.filter(
                    entity => this.administrableEntitiesUids.includes(entity.uid)
                );
            }
            return this.entities;
        },
        filteredIrds (){
            let irds = this.$store.getters.irds.slice();
            if(this.userIsEntityAdmin()){
                irds = irds.filter(ird =>
                    this.administrableEntitiesUids.includes(ird.scopes.entity_uid)
                );
            }
            if(this.selectedSortType){
                irds.sort((a, b) => a.name.localeCompare(b.name));
                if(this.selectedSortType === 'dsc'){
                    irds.reverse();
                }
            }
            if(this.selectedEntitiesForFilter.length > 0){
                irds = irds.filter((ird) => this.selectedEntitiesForFilter.includes(ird.scopes.entity_uid));
            }
            if(this.selectedTakersForFilter.length > 0){
                irds = irds.filter((ird) => this.selectedTakersForFilter.includes(ird.taker_uid));
            }
            if(this.searchFilter){
                irds = irds.filter((ird) => ird.name.toLowerCase().includes(this.searchFilter.toLowerCase()));
            }
            if(this.selectedRegionsForFilter.length > 0){
                irds = irds.filter((ird) => this.selectedRegionsForFilter.includes(ird.region_uid));
            }
            return irds;
        },
    },

    watch: {
        windowWidth() {
            this.computeFilterHeight();
        }
    },
    mounted (){
        this.$nextTick(() => {
            this.computeFilterHeight();
        });
    },

    methods: {
        computeFilterHeight() {
            if(this.$refs['gcmcn-filters']){
                const clientRect = this.$refs['gcmcn-filters'].$el.getBoundingClientRect();
                this.usedHeight = clientRect.top + clientRect.height + 10 + 32;  // +10 par ce que l'element contient un margin, et les margin ne sont pas comptés dans la height d'un element
                // 32 -> on enleve la height du wrapper d'alerte de fundation
            }
        },
        onSelectRegions (regions) {
            this.$set(this, 'selectedRegionsForFilter', regions);
        },
        onSelectEntity (entities) {
            this.$store.commit('SET_ENTITIES_FOR_FILTER', entities);
        },
        onSelectTakers (takers) {
            this.$store.commit('SET_TAKERS_FOR_FILTER', takers);
        },
        resetFilters (){
            this.selectedSortType = '';
            this.$refs.search.clear();
            this.$set(this, 'selectedRegionsForFilter', []);
            this.$store.commit('CLEAR_ALL_FILTERS');
        },
        changeSelectedIrd (irdUid){
            this.$emit('change-selected-ird', irdUid);
        },
    },
};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/page/Receiver/Ird/irdList.vue